import { Component } from "@angular/core";

@Component({
  selector: "toolbox-app-colors",
  templateUrl: "./app-colors.component.html",
  styleUrls: ["./app-colors.component.scss"],
})
export class AppColorsComponent { }
